import { useRef } from 'react';
import { useBarcode } from '@createnextapp/react-barcode'
import { Box, Button } from '@mui/material';
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';

export const BarcodeGenerator = ({ barcode = "000000000000" }) => {
    const canvasRef = useRef(null);

    const { inputRef } = useBarcode({
        value: barcode,
        options: {
            background: '#FFFFFF',
            textAlign: 'center'
        }
    });

    // attach both refs
    const setRefs = (node) => {
        inputRef.current = node;
        canvasRef.current = node;
    };

    const downloadBarcode = () => {
        if (!canvasRef.current) return;

        const url = canvasRef.current.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = url;
        link.download = `barcode-${barcode}.png`;
        link.click();
    };

    return (
        <Box width="100%" display="flex" flexDirection="column" alignItems="center" gap={2} p={2}>
            {
                barcode !== "000000000000" || barcode !== "" ?
                    <>
                        <canvas id="posBarcode" ref={setRefs} />
                        <Button
                            variant="contained"
                            onClick={downloadBarcode}
                            sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1, borderRadius: '12px', boxShadow: 'none', ":hover": { boxShadow: 'none' } }}
                        >
                            <DownloadForOfflineRoundedIcon />
                            Download Barcode
                        </Button>
                    </>
                    :
                    <p>No barcode preview</p>
            }
        </Box>
    );
}